import Vue from "vue"
import DatePicker from 'vue2-datepicker'
import SortedTablePlugin from "vue-sorted-table"
import Paginate from "@/components/widgets/pagination.vue";
import moment from 'moment'
import { mounted } from "vue-simple-suggest";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})

export default {
  components: {
    DatePicker,
    Paginate
  },
  data: function() {
    return {
      role: "",
      branch: "",
      busy: false,
      date_start: null,
      date_end: null,
      perPage: 6,
      sortBy: 'name',
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      totalItem: 0,
      apiStatus: 'กรุณาระบุวันที่และกดปุ่มแสดงข้อมูลเพื่อค้นหาข้อมูล',
      fields: [
        { 
          key: 'index', 
          label: '#', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'document.created_at', 
          label: 'วันที่', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'document.branch_name.name', 
          label: 'สาขา', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'detail.coil', 
          label: 'รหัสสินค้า', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'name', 
          label: 'ชื่อสินค้า', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'detail.brand', 
          label: 'ยี่ห้อ', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'detail.size', 
          label: 'ความหนา                ', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'detail.color', 
          label: 'สี', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'detail.net_weight', 
          label: 'น้ำหนัก', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'detail.length', 
          label: 'จำนวน', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'total_price', 
          label: 'ยอดเงิน ฿', 
          sortable: true,
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'font-weight-bold text-black td-top text-xs-1/2',
          class: 'text-right' 
        },
        { 
          key: 'document.document_no', 
          label: 'เลขที่ใบสำคัญ', 
          sortable: true,
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-black td-top text-xs-1/2',
          class: 'text-right' 
        }
      ],
      items: [

      ],
      form: {
        start_date: new Date(moment().startOf('month').format('YYYY-MM-DD')),
        end_date: new Date(moment().endOf('month').format('YYYY-MM-DD'))
      },
      seller_list: [],
      sum: 0,
    }
  },
  computed: {
    rows() {
      return this.items.length
    }
  },
  methods: {
    async getRole(){
      const res = await this.$store.dispatch('Auth/getRole', {}, { root: true })
      this.role = res.data.role
      this.branch = res.data.branch_id

      if(this.role !== 'Branch Admin'){
        this.fields = this.fields.filter(field => field.key !== 'total_price');
      }
    },
    async onInitData() {
      if(this.role !== 'Branch Admin'){
        this.fields = this.fields.filter(field => field.key !== 'total_price');
      }

      try {
        const item = this.items
        this.items = []
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const res = await this.$axios.get(
          this.$host + "/api/v1/report/coiltransaction?keyword_startdate="+moment(this.form.start_date).format('YYYY-MM-DD')+"&keyword_enddate="+moment(this.form.end_date).format('YYYY-MM-DD'),
                )
        
        const data = res.data

        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.items = data.data
        this.sum = data.sum

      } catch (error) {
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    exportPDFReport() {
      this.loading = true;
      setTimeout(async () => {
        this.loading = true

        const result = await this.$axios.get(
          this.$host + "/api/v1/report/pdf/coiltransaction?keyword_startdate="+moment(this.form.start_date).format('YYYY-MM-DD')+"&keyword_enddate="+moment(this.form.end_date).format('YYYY-MM-DD'),

          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            responseType: "blob",
          }
        );
        const blob = new Blob([result.data], { type: "application/pdf" });
        const objectUrl = URL.createObjectURL(blob);
        var isSafari = /^((?!chrome|android).)*safari/i.test(
          navigator.userAgent
        );
        if (isSafari) {
          window.open(objectUrl)
          // const link = document.createElement('a')
          // link.href = objectUrl2
          // link.setAttribute('download', 'ใบเสนอราคา ' +  + '.pdf')
          // document.body.appendChild(link)
          // link.click()

          this.loading = false;
        } else {
          window.open(
            objectUrl,
            "targetWindow",
            `toolbar=no,
           location=no,
           status=no,
           menubar=no,
           scrollbars=yes,
           resizable=yes,
           width=SomeSize,
           height=SomeSize`
          );
          this.loading = false;
        }
        // URL.revokeObjectURL(objectUrl);
      }, 1000);
    },
    async exportExcelReport() {
      try {
        this.loading = true;
        
        const response = await this.$axios.get(
          this.$host + "/api/v1/report/excel/coiltransaction?keyword_startdate="+moment(this.form.start_date).format('YYYY-MM-DD')+"&keyword_enddate="+moment(this.form.end_date).format('YYYY-MM-DD'),
          { responseType: 'blob' }
        );
    
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Roll transaction report.xls`);
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Cleanup after click
    
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || "An error occurred while downloading the file.");
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted(){
    await this.getRole()
  }
}